<template>
  <div>
    <b-row>
      <b-col cols="8">
        <div class="card">
          <div class="card-body">
            <b-form @submit="onSubmit">
              <input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id"/>
              <b-form-group label="Question Text" class="required">
                <b-form-input
                  type="text"
                  id="dataItem-questionText-input"
                  class="form-input"
                  :class="{ 'is-invalid': $v.dataItem.questionText.$error }"
                  v-model="dataItem.questionText"
                  @blur="$v.dataItem.questionText.$touch()"
                ></b-form-input>
                <b-form-invalid-feedback>Question Text is required</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Question Type" class="required">
                <b-form-input
                  type="text"
                  id="dataItem-questionType-input"
                  class="form-input"
                  :class="{ 'is-invalid': $v.dataItem.questionType.$error }"
                  v-model="dataItem.questionType"
                  @blur="$v.dataItem.questionType.$touch()"
                ></b-form-input>
                <b-form-invalid-feedback>Question Type is required</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Active">
                <b-form-checkbox
                  id="dataItem-active-input"
                  class="form-input"
                  v-model="dataItem.active">active
                </b-form-checkbox>
              </b-form-group>
              <b-button  :disabled="isSaving" type="submit" variant="primary" style="margin: 5px;"><i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
              <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  import service from '../../service';
  import { dataItemDto } from '../../dto';

  export default {
    name: 'edit',
    data: () => ({
      dataItem: {},
      isSaving:false
    }),
    computed: {
      id() {
        return this.$route.params.id;
      },
    },
    methods: {
      getRecord() {
        this.setContainerLoader(true);
        service.getById(this.id).then(data => {
          this.dataItem = data;
          this.setContainerLoader(false);
        }).catch(() => {
          this.setContainerLoader(false);
          //return back to listing page because error in fetch record
          this.$router.push({name: 'interviewquestions'});
        });
      },
      async onSubmit(e) {
        e.preventDefault();

        this.$v.dataItem.$touch();
        if (this.$v.dataItem.$invalid) {
          return;
        }

        try {
          let payload = new dataItemDto(this.dataItem);
          this.isSaving = true;
          try {
            const id = await service.update(payload);
            this.cancel();
          } catch {
          }
          this.isSaving = false;
        }catch (e) {
          this.isSaving = false;
        }
      },
      cancel() {
        this.$router.push({ name: 'interviewquestions' });
      },
    },
    mounted() {
      this.getRecord(this.id);
    },
    validations: {
      dataItem: {
        questionText: { required },
        questionType: { required },
      },
    },
  };
</script>
